import { usePortal } from 'hooks/hooks'
import { queryParamToBoolean } from 'utils/methods'
import { AcceptableUsePolicyPage } from 'components/policy/AcceptableUsePolicyPage'
import { NextPageWithLayout } from 'pages/_app'
import PortalLayout from 'layouts/Portal'

const AcceptableUsePolicy: NextPageWithLayout = () => {
    const [, router] = usePortal()

    return (
        <AcceptableUsePolicyPage
            isPreview={queryParamToBoolean(router.query.preview, false)}
        />
    )
}

AcceptableUsePolicy.getLayout = (page) => <PortalLayout>{page}</PortalLayout>

export default AcceptableUsePolicy
